module.exports = __webpack_public_path__ + "img/LOGO.a148591b.svg";